<template>
  <div class="contentPrimary boxRhDetails">
    <div class="mdl-grid alignItems">
      <div class="mdl-cell mdl-cell--2-col">
        <img src="@/assets/img/icon_info.png" alt="location" width="45" />
      </div>
      <div
        class="mdl-cell mdl-cell--10-col"
        v-if="ticket.cf_list?.cf_sold_solution"
      >
        <p class="label">
          {{ $t("detailsTicket.IncidentDetailSolutionLabel") }}
        </p>
        <span class="text">{{ ticket.cf_list.cf_sold_solution }}</span>
      </div>
      <div class="mdl-cell mdl-cell--10-col" v-else>
        <span class="label">{{ $t("tickets.defaultDetailTitle") }}</span>
      </div>
      <div class="mdl-cell mdl-cell--12-col">
        <hr />
      </div>

      <div
        v-if="ticket.cf_list?.cf_severity_level_picklist"
        class="mdl-cell mdl-cell--2-col"
      >
        <img src="@/assets/img/icon_operation.png" alt="operation" width="45" />
      </div>
      <div
        class="mdl-cell mdl-cell--10-col"
        v-if="ticket.cf_list?.cf_severity_level_picklist"
      >
        <div>
          <span class="label">{{ $t("help.incident.severityLevel") }}</span>
          <span class="text" style="margin-left: 3px">{{
            ticket.cf_list.cf_severity_level_picklist
          }}</span>
        </div>
      </div>
      <div
        v-if="ticket.cf_list?.cf_severity_level_picklist"
        class="mdl-cell mdl-cell--12-col"
      >
        <hr />
      </div>

      <slot name="colocation-category"></slot>

      <!-- Reference Details -->
      <div class="mdl-cell mdl-cell--2-col">
        <img src="@/assets/img/icon_reference.png" alt="reference" width="45" />
      </div>
      <div class="mdl-cell mdl-cell--10-col">
        <span class="label">{{ $t("tickets.referent") }}</span>
        <div>
          <span class="label">{{ $t("accessDc.name") }}</span>
          <span class="text" style="margin-left: 3px"
            >{{
              (ticket.cf_list?.cf_nome_referente || "--") +
              " " +
              (ticket.cf_list?.cf_cognome_referente || "--")
            }}
          </span>
        </div>
        <div>
          <span class="label">{{ $t("refTicket.phoneRef") }}</span>
          <span class="text" style="margin-left: 3px">{{
            ticket.cf_list?.cf_telefono_referente || "--"
          }}</span>
        </div>
        <div>
          <span class="label">{{ $t("refTicket.emailRef") }}</span>
          <span class="text" style="margin-left: 3px">{{
            ticket?.cf_list?.cf_email_referente || "--"
          }}</span>
        </div>
      </div>

      <hr />

      <!-- Richiedente User Details -->
      <div class="mdl-cell mdl-cell--2-col">
        <img src="@/assets/img/icon_reference.png" alt="reference" width="45" />
      </div>
      <div class="mdl-cell mdl-cell--10-col">
        <span class="label">{{ $t("tickets.requesting") }}</span>
        <div>
          <span class="label">{{ $t("accessDc.name") }}</span>
          <span class="text" style="margin-left: 3px">
            {{
              (ticket?.created_by?.first_name || "--") +
              " " +
              (ticket?.created_by?.last_name || "--")
            }}</span
          >
        </div>
        <div>
          <span class="label">{{ $t("help.assigneePhone") }}</span>
          <span class="text" style="margin-left: 3px">
            {{ ticket?.created_by?.phone || "--" }}
          </span>
        </div>
        <div>
          <span class="label">{{ $t("help.assigneeEmail") }}</span>
          <span class="text" style="margin-left: 3px">
            {{ ticket?.created_by?.email || "--" }}
          </span>
        </div>
      </div>
      <div class="mdl-cell mdl-cell--12-col">
        <hr />
      </div>
    </div>
  </div>
</template>

<script>
import { useUserStore } from "@/stores/UserStore";

export default {
  name: "HelpRequestDetailBox",
  data() {
    return {
      userStore: {},
    };
  },
  props: {
    ticket: Object,
  },
  mounted() {
    this.userStore = useUserStore();
  },
};
</script>
